import { logError } from '@zg-rentals/log-error';

import UserActions from '../../flux/actions/UserActions';
import filterUtils from '../../utils/filterUtils';
import pathsManifest from '../../utils/pathsManifest';
import { decodeAddressComponentsFromUrl, isLegacyPmrAddressSlug } from '../../utils/urlUtils';
import { loadFilterFromUrl } from '../../flux/actions/FilterActions';
import { getAddressAndComparables } from '../../flux/actions/AddressActions';

const serverRouteWillMount = ({ store }: { store: any }) => {
  const { dispatch } = store;
  const state = store.getState();
  const pathname = state.router.location.pathname;
  const queryObject = state.router.location.query;
  const queryString = state.router.location.search;

  // Decode and parse the address from URL into individual components

  const addressComponents = decodeAddressComponentsFromUrl(
    {
      pathname,
      unit: queryObject.unit,
    },
    (error) => {
      logError({
        error,
        errorType: 'Address',
        context: {
          details: 'Results page: Error parsing address from URL (SSR)',
          root: 'pages/PriceMyRentalResultsPage#serverRouteWillMount',
          pathname,
        },
      });
    },
  );

  // Legacy PMR URLs (hyphen-only slug, no comma separators) can't be parsed into a
  // real address and would render a dead results page. Redirect to the PMR landing
  // page with the decoded address prefilled so users land one autocomplete-click away.
  if (isLegacyPmrAddressSlug(addressComponents.name)) {
    return Promise.resolve({
      redirect: true,
      code: 302,
      to: {
        pathname: `${pathsManifest.PriceMyRentalPage}/`,
        query: { address: addressComponents.name },
      },
    });
  }

  // Get user info
  dispatch(UserActions.getUser());

  const filterParams = filterUtils.queryStringToApiParams(queryString);
  const params = {
    ...addressComponents,
    ...filterParams,
  };

  // @ts-ignore
  dispatch(loadFilterFromUrl(queryObject)).catch((err) => {
    logError({
      error: err,
      errorType: 'Filter',
      context: {
        details: 'Results page: Error loading filter from url (SSR)',
        root: 'pages/PriceMyRentalResultsPage#serverRouteWillMount',
      },
    });
  });

  // @ts-ignore
  return dispatch(getAddressAndComparables(params)).catch((err) => {
    logError({
      error: err,
      errorType: 'Address',
      context: {
        details: 'Results page: Error loading address/comps (SSR)',
        root: 'pages/PriceMyRentalResultsPage#serverRouteWillMount',
        pathAttempted: pathname,
        queryAttempted: queryString,
      },
    });
  });
};
export default serverRouteWillMount;
